import "./service-categories-card.css";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

function ServiceCategoriesCard({
  data,
  isNavModalOpen,
  setIsNavModalOpen,
  hoveredCardId,
  setHoveredCardId
}) {
  const { id, title, img, serviceUrl } = data;

  const navigate = useNavigate();

  const { ref, inView } = useInView({
    threshold: 0.8,
  });

  const handleMouseEnter = () => setHoveredCardId(id);
  const handleMouseLeave = () => setHoveredCardId(null);

  const isDimmed = hoveredCardId !== null && hoveredCardId !== id;

  return (
    <div
      className={`service-categories-card ${window.innerWidth <= 768 ? (inView ? "card-in-view" : "") : null
        } ${isDimmed ? "dimmed" : ""}`}
      ref={ref}
      onClick={() => {
        navigate("/services", { state: { scrollToId: serviceUrl } });
        if (isNavModalOpen !== null) {
          setIsNavModalOpen(false);
        }
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={img} alt={`${title} Service Img`} />
      <div className="title">
        <h1>{title}</h1>
        <div className="title-border"></div>
      </div>
    </div>
  );
}

export default ServiceCategoriesCard;
